

export const onConfirm = (callBack) => (e) => {
        console.log('key', e.key, e.wich);
        if ( e.key === 'Enter' || e.wich === 13) {
            return callBack();
        }
    }

